import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import Util from "../../util/util";

const slice = createSlice({
  name: "time",
  initialState: {
    currentWeek: null,
    currentSeason: null,
  },
  reducers: {
    setupTime: (time, action) => {
      console.log(`(redux) time.setup`);

      const currentSeason = Util.getCurrentSeason();
      console.log(`(redux) currentSeason: ${currentSeason}`);

      const currentWeek = Util.getCurrentWeek();
      console.log(`(redux) currentWeek: ${currentWeek}`);

      time.currentSeason = currentSeason;
      time.currentWeek = currentWeek;
    },
  },
});

export default slice.reducer;

const { setupTime } = slice.actions;

// action creators

export const runTimeSetup = () => (dispatch) => {
  dispatch(setupTime());
};

// selector helper functions

const getProp = (propName) =>
  createSelector(
    (state) => state.time,
    (time) => time[propName]
  );

// selectors

export const getTimeData = createSelector(
  (state) => state.time,
  (time) => time
);

export const getCurrentSeason = getProp("currentSeason");

export const getCurrentWeek = getProp("currentWeek");

export const getCurrentWeekForUrl = createSelector(
  (state) => state.time,
  (time) => {
    return Util.weekToUrl(time.currentWeek);
  }
);
